import React from 'react';
import { Box, Flex, Text, useToast } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SEHomeCard } from '../../../../common/components/SEHomeCard';
import { SlidingAnimationPageBase } from '../../../../common/components/SlidingAnimationPageBase';
import { useParamBackUrl } from '../../../../common/hooks/use-param-back-url';
import { AccountMenuButton } from '../../AccountMenuButton';
import { ConsentManagementButton } from './ConsentManagementButton';
import { CustomerSupportConsentToggle } from './CustomerSupportConsentToggle';
import { openPrivacyNoticePdfInWebView } from './privacy-notice-pdf';

export function PrivacySettingsHome() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const toast = useToast({ isClosable: true });
  const backURL = useParamBackUrl('../home?direction=back');

  async function handleOpenPrivacyNotice() {
    try {
      await openPrivacyNoticePdfInWebView(i18n.language);
    } catch (error) {
      console.error('Failed to open Privacy Notice PDF:', error);
      toast({
        title: t('Common.something went wrong'),
        description: t('Common.please try again'),
        status: 'error',
      });
    }
  }

  return (
    <SlidingAnimationPageBase backURL={backURL} title={t('Account.privacy settings')}>
      <Box px={5}>
        <Text pt={5} pb={2} fontSize="sm" color="gray.500">
          {t('Account.privacy settings').toUpperCase()}
        </Text>

        <SEHomeCard mb={3} borderTopLeftRadius="5px">
          <CustomerSupportConsentToggle />
        </SEHomeCard>

        <SEHomeCard p={0} borderTopLeftRadius="5px">
          <AccountMenuButton data-testid={'data-archive-button'} onClick={() => navigate(`data-archive`)}>
            <Flex align="center">
              <Text fontSize={16} fontWeight="normal">
                {t('Data Archive.data archive')}
              </Text>
            </Flex>
          </AccountMenuButton>

          <AccountMenuButton data-testid={'delete-account-button'} onClick={() => navigate(`delete-account`)}>
            <Flex align="center">
              <Text fontSize={16} fontWeight="normal">
                {t('Account.delete my account')}
              </Text>
            </Flex>
          </AccountMenuButton>

          <AccountMenuButton
            data-testid={'privacy-notice-button'}
            includeBottomDivider={false}
            onClick={handleOpenPrivacyNotice}
          >
            <Flex align="center">
              <Text fontSize={16} fontWeight="normal">
                {t('Privacy Notice.privacy notice')}
              </Text>
            </Flex>
          </AccountMenuButton>
        </SEHomeCard>

        <ConsentManagementButton />
      </Box>
    </SlidingAnimationPageBase>
  );
}
